export default __webpack_public_path__ + "static/media/team.938d6101.svg";